import Cookies from "js-cookie";
import service from "../Services/apiheader";
import axios from "axios";

export const GET_API=process.env.REACT_APP_API_GETWAY+`/`;
export const accessToken = Cookies.get('ACCESS_TOKEN');
export const fetchGridFields = async (params: { module: string; gridName: string }) => {
  try {
    const response = await axios.get(`${GET_API}cm/form-manager/grids/fields`, {
      params: params,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Accept-Language': ''
      }
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching grid fields:", error);
    throw error;
  }
};

export const fetchFormFields = async (params: { module: string; formName: string }) => {
  try {
    const response = await axios.post(`${GET_API}cm/form-manager/forms/settings`, {
    ...params
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return JSON.parse(response.data.data.settingsJson);
  } catch (error) {
    console.error("Error fetching grid fields:", error);
    throw error;
  }
};

export const fetchUAMpreveligies = async() =>{ 
    const requestbody={
      "userId": Cookies.get('USER_ID'),
      "resourceType": "",
      "app": "",
      "module": "",
      "subModule": "",
      "parentId": null
    }
    const response=await service.post(`${GET_API}common-uam/resources/specified/related-list`, requestbody); 
    return response.data.data;
  }

export const fetcheligibleregistrations = async (payload: any) => {
  const response = await service.post(
    `xevmpd/validate-reg-packages`,
    payload,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        "Accept-Language": ""
      }
    }
  );
  return response.data;
}

  export const fetchXevmpdList = async(params:any) =>{ 
   const response = await service.post(
        `xevmpd/v1/display-all`,
        {
          page: params.page,
          size: params.pageSize,
          active: params.showActive,
          submitted: params.showSubmitted,
          deleted: params.showDeleted,
          globalFilters: params.globalFilters || [],
          conditionFilter:params.conditionFilter,
          sortField:params.sortField,
          searchFilter:params.searchFilter,
          sortType:params.sortType
        },
        {
          headers: {
            "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            "Accept-Language": ""
          }
        }
      );
    return response.data.data;
  }
   export const createxEVMPDExportTask = async(params:any,downloadtype:string) =>{ 
   const response = await service.post(
        `/xevmpd/v1/export/task?format=${downloadtype}`,
        {
          page: params.page,
          size: params.pageSize,
          active: params.showActive,
          submitted: params.showSubmitted,
          deleted: params.showDeleted,
          globalFilters: params.globalFilters || [],
          conditionFilter:params.conditionFilter,
          sortField:params.sortField,
          searchFilter:params.searchFilter,
          sortType:params.sortType
        },
        {
          headers: {
            "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            "Accept-Language": ""
          }
        }
      );
    return response.data;
  }
export const getxEVMPDExportTaskStatus = async (taskid: string) => {
  const response = await service.get(`${GET_API}xevmpd/v1/export/task/${taskid}`);
  return response;
}

export const fetchRegistrationData = async (page: number, pageSize: number, regioncodes: any[], producttypekmcode: any[], regstatuscodes: any[],LocalRegistrationCategoryKMCodes:any[]) => {
  try {
    const response = await service.post(`${GET_API}registration/external/registration/page`,
      {
        kmFlag: false,
        pageSize: pageSize,
        pageNum: page,
        orderBy: "modified_date",
        // sort: "des",
        filters: [
          // {
          //   field: "ProductType",
          //   values: producttypekmcode.map(code => `ProductType_${code}`)
          // },
          // {
          //   field: "RegulatoryStatus",
          //   values: regstatuscodes.map(code => `RegulatoryStatus_${code}`)
          // },
          {
            field: "localRegistrationCategory",
            values: LocalRegistrationCategoryKMCodes.map(code => `LocalRegistrationCategory_${code}`)
          },
          {
            field: 'region',
            values: regioncodes.map(code => `CountryGroup_${code}`)
          }
        ]
      },
      {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('API call failed:', error);
  }
};

export const fetchRelatedProducts = async (productId: any) => {
  try {
    const response = await service.post(`${GET_API}product/system/product/related/page`,
      {
        kmFlag: false,
        section: 'Packages',
        menu: 'Packages',
        productIds: [productId],
        pageNum: 1,
        pageSize: 1000000,
      },
      {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      }
    );

    return response.data;
  } catch (error: any) {
    console.error('API call failed:', error.response?.data || error.message);
    return null;
  }
};

export const createXevmpd = async (
  payload: any[],
) => {
  try {
    const response = await service.post(
      "xevmpd/v1/addition",
      payload,
      {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': 'en',
        },
      }
    );
    const responseData =  response;
    console.log('Success:', responseData);
    return responseData;
  } catch (error) {
    console.error('Failed to call createXevmpd:', error);
    return null;
  }
};

 export const fetchSideMenu = async () => {
  const response = await service.get(`${GET_API}cm/form-manager/menus/module?module=xevmpd&domain=All`);
  
  const modifiedData = response.data.data.map((item: any) => {
    if (item.displayName === 'Authorized Product') {
      return {
        ...item,
        displayName: 'Authorised Product'
      };
    }
    return item;
  });
  
  return modifiedData;
};

export const fetchSideMenuData=async(params:any)=>{
  const response = await service.get(
      `xevmpd/v1/getDataByMenu`,
      {
        params:params,
        headers: {
          
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': 'en',
        },
      }
    );
   return response.data.data;   
}

export const getMissingFields=async(regId:any)=>{
   const response= await service.get(`xevmpd/v1/mandatoryfield/${regId}`,
    {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': 'en',
        },
      }
   );
   console.log(response);
   return response.data.data;
}

export const fetchXevmpdDataById=async(id:any)=>{
  const response = await service.get(`xevmpd/v1/display/${id}`,
    {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': 'en',
        },
      }
  );
  return response.data.data;
}

export const updatexEVMPDRecord = async(id:any,payload:any,isDataSync: boolean)=>{
const response = await service.put(`xevmpd/v1/update/${id}?isDataSync=${isDataSync}`,payload,
  {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': 'en',
        },
      }
);
return response;
}

 export const fetchReasons = async () => {
      const response = await service.get(
        `${GET_API}cm/dropdown-list?module=xevmpd&label=ReasonForDisable`,
      );
      return response.data.data;
};

export const disablexEVMPD = async (params: any, id: any) => {
  const response = await service.put(
    `xevmpd/v1/disable/${id}`,
    params, 
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "en",
      },
    }
  );
  return response;
};



export const fetchSideMenuDataById=async(params:any)=>{
  const response = await service.get(
      `xevmpd/v1/display?menu=${params.name}&xevmpdId=${params.xevmpdId}`,{
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': 'en',
        },
      }
    );
   return response.data.data;   
}

export const fetchRegistrationById = async (regid: number) => {
  try {
    const response = await service.post(`${GET_API}registration/system/registrations/query`,
      {
        "kmFlag": false,
        "registrationIds": [regid],
        "selectMarkType":2
      },
      {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('API call failed:', error);
  }
};

export const addSideMenuRecord = async (payload: any, file?: File) => {
  const formData = new FormData();
  console.log("PAYLOAD:",payload, file);

  if (file) {
    formData.append("file", file);
  }

   formData.append(
      "data",
      new Blob([JSON.stringify(payload)], { type: "application/json" })
    );
  const it = formData.entries();
let entry = it.next();
while (!entry.done) {
  console.log(entry.value[0], entry.value[1]);
  entry = it.next();
}


  const response = await axios.post(
    `${GET_API}xevmpd/related/v1/addition`,
    formData,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "",
        "Content-Type":"multipart/form-data"
      },
    }
  );

  return response.data.data;
};


export const getSideMenuRecord=async(id:any)=>{
  const response=await service.get(`xevmpd/related/v1/display/${id}`,
    {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': '',
        },
      }
  );
  return response.data.data;
}

export const updateSideMenuRecord = async (payload: any, file?: File) => {
  const formData = new FormData();
  console.log("PAYLOAD:", payload, file);
  if (file) {
    formData.append("file", file);
  }

  formData.append(
    "data",
    new Blob([JSON.stringify(payload)], { type: "application/json" })
  );

  // Optional: log all FormData entries for debugging
  const it = formData.entries();
  let entry = it.next();
  while (!entry.done) {
    console.log(entry.value[0], entry.value[1]);
    entry = it.next();
  }

  const response = await axios.put(
    `${GET_API}xevmpd/related/v1/modification`,
    formData,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "",
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data.data;
};


export const fetchAcknowledgementByXevmpdId = async (xevmpdid: number, params:any) => {
  const sectionName = params.menuName==="Acknowledgements" ? params.menuName : params.sectionName;
  try {
    const response = await service.post(`xevmpd/related/v1/display-all?xevmpdId=${xevmpdid}&section=${sectionName}&menu=${params.menuName}`,
      {
        "page": 0,
        "size": 30
      },
      {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('API call failed:', error);
  }
};

export const downloadAckAttachment = async (id:any) => {
  const accessToken = Cookies.get("access_token");
  const tenantId = Cookies.get("USER_TENANT_ID") || "0";
  console.log("DOwnLOAD ID:",id);
  
  try {
    const response = await service.post(
      `xevmpd/related/v1/file/download?xevmpdRelatedId=${id}`,
      {},
      {
        headers: {
          "x-tenant-id": tenantId,
          "Authorization": `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          "Accept-Language": ""
        },
        responseType: 'blob'
      }
    );

    // Extract filename from response headers
    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'attachment';
    
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1];
      }
    }

    // Create download
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true, fileName };
  } catch (error:any) {
    console.error('Download failed:', error);
    
    // Handle specific error cases based on your API response
    if (error.response?.status === 404) {
      return { success: false, error: 'File not found' };
    }
    
    return { success: false, error: 'Download failed. Please try again.' };
  }
};

export const downloadXML = async (id: any) => {
  try {
    const response = await service.get(`xevmpd/xml/download/${id}`, {
      responseType: "blob",
    });

    const blob = new Blob([response.data], { type: "application/xml" });
    const url = window.URL.createObjectURL(blob);

    const contentDisposition = response.headers["content-disposition"];
    const filenameMatch = contentDisposition?.match(/filename="?([^"]+)"?/);
    const fileName = filenameMatch ? filenameMatch[1] : `xevmpd_${id}.xml`;

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true, fileName };
  } catch (error) {
    console.error("Error downloading XML:", error);
  }
};

export const viewXML = async (id: any) => {
  try {
    const response = await service.get(`xevmpd/xml/view/${id}`, {
      headers: { Accept: "application/xml" },
      responseType: "blob", // ensures binary/XML data handling
    });

    const xmlBlob = new Blob([response.data], { type: "application/xml" });
    const xmlURL = URL.createObjectURL(xmlBlob);

    // Open in a new tab for viewing
    window.open(xmlURL, "_blank");

  } catch (error) {
    console.error("Error viewing XML:", error);
  }
};

export const fetchDataListByMenu = async (params: any) => {
  const response = await service.get(
    `xevmpd/v1/getDataListByMenu`,
    {
       params: params,
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "en",
      },
    }
  );
  return response.data.data;
};

export const fetchAllSideMenuData = async (params: any) => {
  const response = await service.get(
    `xevmpd/v1/display/all?menu=${encodeURIComponent(params.name)}&xevmpdId=${params.xevmpdId}&section=${encodeURIComponent(params.section)}`,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "en",
      },
    }
  );
  return response.data.data;
};


export const downloadExcelReport = async (id: any) => {
  try {
    const response = await service.get(`/xevmpd/v1/report/download/${id}`, {
      responseType: "blob", // important for binary file
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "en",
      },
    });

    // Extract filename from response headers (if provided)
    const contentDisposition = response.headers["content-disposition"];
    const fileNameMatch = contentDisposition && contentDisposition.match(/filename="?([^"]+)"?/);
    const fileName = fileNameMatch ? fileNameMatch[1] : `xEVMPD_Report_${id}.xlsx`;

    // Create blob and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true, fileName };

  } catch (error) {
    console.error("Error downloading report:", error);
  }
};

export const fetchPharmaceuticalProductData = async (params: any) => {
  const response = await service.get(
    `xevmpd/v1/getPharmaceuticalProductData`,
    {
      params:params,
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "en",
      },
    }
  );
  return response.data.data;
};


export const addSideMenuRecordV2 = async (payload: any) => {
  try {
    const response = await service.post('xevmpd/related/v2/addition',payload, {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': 'en',
        },
      });
    return response.data.data;
  } catch (error: any) {
    console.error('Error adding related record:', error);
    throw error;
  }
};

export const updateSideMenuRecordV2 = async (payload: any) => {
  try {
    const response = await service.put('xevmpd/related/v2/modification',payload, {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': 'en',
        },
      });
    return response.data.data;
  } catch (error: any) {
    console.error('Error adding related record:', error);
    throw error;
  }
};

export const disableRelatedRecord = async (params: any, id: any) => {
  try {
   
    
    const response = await service.put(`xevmpd/related/v2/status-disable/${id}`, params,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "en",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error('Error disabling related record:', error);
    throw error;
  }
};

export const fetchDropdownValues = async (url: any) => {
  try {
    const response = await service.get(`${GET_API.slice(0,-1)}${url}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching dropdown values:', error);
    return [];
  }
};

export const getGridDataById = async (xevmpdId: number, menu: string, index: number) => {
  const response = await service.get(
    `xevmpd/v1/display/gridData/byId?xevmpdId=${xevmpdId}&menu=${encodeURIComponent(menu)}&index=${index}`,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        'Accept-Language': '',  
      }
    }
  );
  console.log(response);
  return response.data.data;
};

export const submitOnline=async(id:any,user:string)=>{
  const response=await service.get(`xevmpd/related/v1/submit?xevmpdId=${id}&createdBy=${user}`,{
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        'Accept-Language': '',  
      }
    });
    console.log(response);

    return response.data;
}

export const getAuditInfo = async (xevmpdId: number) => {
  const response=await service.get(`xevmpd/v1/audit-info/${xevmpdId}`,{
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        'Accept-Language': '',    
      }
    });
    return response.data.data;
    
}
const namesToMatch = [
  "European Union / European Economic Area",
  "EU",
  "European Union",
  "EEA",
  "Drug",
  "Valid",
  "Approved",
  "Notified",
  "Vaccine",
  "Biologic",
  "Pharmaceutical"
].map(name => name.toLowerCase());

const getCodesFromResponse = (response: any[]) => {
  return response
    .filter(item => namesToMatch.includes(item.name?.toLowerCase()))
    .map(item => item.code);
};
export const getRegionKMCodes = async () => {
  const response = await service.get(
    `${GET_API}km/api/v4/node`,
    {
      params: {
        concept: "CountryGroup",
        page: 1,
        page_size: 500,
        data_status: 0,
        concept_operator: "equals"
      },
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "",
      },
    }
  );

  return getCodesFromResponse(response.data?.data?.data);
};

// export const getProductTypeKMCodes = async () => {
//   const response=await service.get(`${GET_API}km/api/v4/node?concept=ProductType`,{
//       headers: {
//         "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
//         Authorization: `Bearer ${accessToken}`,
//         'Accept-Language': '',    
//       }
//     });
//     return getCodesFromResponse(response.data.data.data);
// }
export const getProductTypeKMCodes = async () => {
  const response = await service.get(
    `${GET_API}km/api/v4/node?concept=ProductType&page=1&page_size=500&data_status=0&concept_operator=equals`,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "",
      },
    }
  );

  return getCodesFromResponse(response.data.data.data);
};

export const LocalRegistrationCategoryCodes = async () => {
  const response = await service.get(
    `${GET_API}km/api/v4/node?concept=LocalRegistrationCategory&page=1&page_size=500&data_status=0&concept_operator=equals`,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": "",
      },
    }
  );

  return getCodesFromResponse(response.data.data.data);
};

export const getRegulatorystatusKMCodes = async (regstatus:string) => {
  const response=await service.get(`${GET_API}km/api/v4/node?concept=RegulatoryStatus&name=${regstatus}`,{
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${accessToken}`,
        'Accept-Language': '',    
      }
    });
    return getCodesFromResponse(response.data.data.data);
}

//Auto tags apis
export const apiGetModuleFields = (domainName: string, moduleName: string): Promise<API.DataResponse<any>> => service.get(`/cm/form-manager/module/fields?domainName=${domainName}&moduleName=${moduleName}`);

export const queryDefaultIdentifier = (body: any): Promise<API.DataResponse<any>> => service.post(`xevmpd/system/identifiers/query-autoTag`, body);

export const queryAllIdentifiers = (): Promise<API.DataResponse<any>> => service.get(`common-uam/identifiers/getOnboardedIdentifiers`);


export const getPackAuthorisationDetail = async (regId: any) => {
  try {
    const response = await axios.get(`${GET_API}registration/registrations/related/page`,
      {
        params: {
          pageNum: 1,
          pageSize: 1000000,
          section: "Registration Information",
          menu: "Pack Authorisation",
          registrationId: regId,
        },
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': '',
        },
      }
    );
 
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

 export const LinkedRecordQueryIdentifier = async (payload: any) => {
  const response = await axios.post(
    `${GET_API}xevmpd/system/identifiers/query`,
    payload,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID") || "0",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        "Accept-Language": "",
        "Content-Type": "application/json"
      },
    }
  );

  return response;
};